export default __webpack_public_path__ + "static/cert-6-img-a9d45c265feaab7774322cde0ed9e91a.png";